"use strict";
/*
 * Created on 10 14 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ExportedDataIdentifier_1 = require("../../model/simple-export/ExportedDataIdentifier");

var SimpleExportedEntity_1 = require("../../model/simple-export/SimpleExportedEntity");

var SimpleExportedEntityConverter_1 = require("./SimpleExportedEntityConverter");
/**
 * @author Jaroslav Sevcik
 */


var SimpleExportedEntityConverterImpl =
/*#__PURE__*/
function (_SimpleExportedEntity) {
  _inherits(SimpleExportedEntityConverterImpl, _SimpleExportedEntity);

  function SimpleExportedEntityConverterImpl() {
    _classCallCheck(this, SimpleExportedEntityConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(SimpleExportedEntityConverterImpl).apply(this, arguments));
  }

  _createClass(SimpleExportedEntityConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new SimpleExportedEntity_1.SimpleExportedEntity(conversions.documentToClassId(source), conversions.asEnum(source.dataIdentifier, ExportedDataIdentifier_1.ExportedDataIdentifier), conversions.toDate(source.created), source.publicPath, source.path, source.deleted);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var document = {};
      Object.assign(document, conversions.classToDocumentId(source));
      Object.assign(document, {
        dataIdentifier: source.dataIdentifier,
        created: conversions.fromDate(source.created),
        publicPath: source.publicPath,
        path: source.path,
        deleted: source.deleted
      });
      return document;
    }
  }]);

  return SimpleExportedEntityConverterImpl;
}(SimpleExportedEntityConverter_1.SimpleExportedEntityConverter);

exports.SimpleExportedEntityConverterImpl = SimpleExportedEntityConverterImpl;